import pin1 from '@pvAssets/img/map-pin-1.png';
import pin2 from '@pvAssets/img/map-pin-2.png';
import pin3 from '@pvAssets/img/map-pin-3.png';
import pin4 from '@pvAssets/img/map-pin-4.png';
import pin5 from '@pvAssets/img/map-pin-5.png';
import pin6 from '@pvAssets/img/map-pin-6.png';
import pin7 from '@pvAssets/img/map-pin-7.png';
import pin8 from '@pvAssets/img/map-pin-8.png';
import pin9 from '@pvAssets/img/map-pin-9.png';
import pin10 from '@pvAssets/img/map-pin-10.png';
import pin11 from '@pvAssets/img/map-pin-11.png';
import pin12 from '@pvAssets/img/map-pin-12.png';
import pin13 from '@pvAssets/img/map-pin-13.svg';
import pin14 from '@pvAssets/img/map-pin-14.svg';
import pin15 from '@pvAssets/img/map-pin-15.svg';
import pin16 from '@pvAssets/img/map-pin-16.svg';
import pin17 from '@pvAssets/img/map-pin-17.svg';
import pin18 from '@pvAssets/img/map-pin-18.svg';
import pin19 from '@pvAssets/img/map-pin-19.svg';
import pin20 from '@pvAssets/img/map-pin-20.svg';
import pin21 from '@pvAssets/img/map-pin-21.svg';
import pin22 from '@pvAssets/img/map-pin-22.svg';
import pin23 from '@pvAssets/img/map-pin-23.svg';
import pin24 from '@pvAssets/img/map-pin-24.svg';
import pin25 from '@pvAssets/img/map-pin-25.svg';
import pin26 from '@pvAssets/img/map-pin-26.svg';
import activePin1 from '@pvAssets/img/map-pin-active-1.svg';
import activePin2 from '@pvAssets/img/map-pin-active-2.svg';
import activePin3 from '@pvAssets/img/map-pin-active-3.svg';
import activePin4 from '@pvAssets/img/map-pin-active-4.svg';
import activePin5 from '@pvAssets/img/map-pin-active-5.svg';
import activePin6 from '@pvAssets/img/map-pin-active-6.svg';
import activePin21 from '@pvAssets/img/map-pin-active-21.svg';
import activePin22 from '@pvAssets/img/map-pin-active-22.svg';
import activePin23 from '@pvAssets/img/map-pin-active-23.svg';
import activePinDs from '@pvAssets/img/map-pin-active-ds.svg';

import {IconTypesEnum} from "@pv/enums/mapIconTypes.ts";

const MapIconTypeToIconMap = {
    [IconTypesEnum.STANDARD_POSTER]: pin1,
    [IconTypesEnum.ACTION_POSTER]: pin2,
    [IconTypesEnum.STANDARD_CLP]: pin3,
    [IconTypesEnum.ACTION_CLP]: pin4,
    [IconTypesEnum.LAST_MINUTE_POSTER]: pin5,
    [IconTypesEnum.LAST_MINUTE_CLP]: pin6,
    [IconTypesEnum.CONFIRMED_POSTER]: pin7,
    [IconTypesEnum.CONFIRMED_CLP]: pin8,
    [IconTypesEnum.FAILED_POSTER]: pin9,
    [IconTypesEnum.FAILED_CLP]: pin10,
    [IconTypesEnum.CANCELLED_POSTER]: pin11,
    [IconTypesEnum.CANCELLED_CLP]: pin12,
    [IconTypesEnum.STANDARD_GD]: pin13,
    [IconTypesEnum.STANDARD_VD]: pin14,
    [IconTypesEnum.CONFIRMED_GD]: pin15,
    [IconTypesEnum.CONFIRMED_VD]: pin16,
    [IconTypesEnum.FAILED_GD]: pin17,
    [IconTypesEnum.FAILED_VD]: pin18,
    [IconTypesEnum.CANCELLED_GD]: pin19,
    [IconTypesEnum.CANCELLED_VD]: pin20,
    [IconTypesEnum.STANDARD_GZ]:pin21,
    [IconTypesEnum.ACTION_GZ]:pin22,
    [IconTypesEnum.LAST_MINUTE_GZ]:pin23,
    [IconTypesEnum.CONFIRMED_GZ]:pin24,
    [IconTypesEnum.FAILED_GZ]:pin25,
    [IconTypesEnum.CANCELLED_GZ]:pin26,
    ACTIVE: {
        [IconTypesEnum.STANDARD_POSTER]: activePin1,
        [IconTypesEnum.ACTION_POSTER]: activePin2,
        [IconTypesEnum.STANDARD_CLP]: activePin3,
        [IconTypesEnum.ACTION_CLP]: activePin4,
        [IconTypesEnum.LAST_MINUTE_POSTER]: activePin5,
        [IconTypesEnum.LAST_MINUTE_CLP]: activePin6,
        [IconTypesEnum.STANDARD_GD]:activePinDs,
        [IconTypesEnum.STANDARD_VD]: activePinDs,
        [IconTypesEnum.STANDARD_GZ]:activePin21,
        [IconTypesEnum.ACTION_GZ]:activePin22,
        [IconTypesEnum.LAST_MINUTE_GZ]: activePin23
    }
};

export default MapIconTypeToIconMap;